module.exports = __webpack_public_path__ + "static/portfolio-mas-9-15119bc19f6da42f3a8f96bc230c9492.jpg";